import dynamic from "next/dynamic";
import { getEndpoint } from '../js/config/helpers';
const RouteWrapper = dynamic(() => import('@components/RouteWrapper'));


// import Category from "../js/Components/Category/Category";
// import ErrorBoundary from "./500";


const DynamicRoute = ({exactRoute, data}) => {
   
    return (
        <>
            <RouteWrapper
                exactRoute={exactRoute}
                data={data}
            />
        </>
    );
};

const getQueryParams = (query) => {
    var additionalQueryParams = "";
    var filter_types_str = "";
    if ("sort" in query) {
        additionalQueryParams =
            additionalQueryParams + "&sort=" + query["sort"];
    }
    if ("filters" in query) {
        filter_types_str = query["filters"];
        additionalQueryParams =
            additionalQueryParams + "&filters=" + filter_types_str;
    }
    var filter_types = filter_types_str.split("|");
    filter_types.forEach((filter_type) => {
        var filter_type_slug = "f-" + filter_type;
        if (filter_type_slug in query) {
            additionalQueryParams =
                additionalQueryParams +
                "&" +
                filter_type_slug +
                "=" +
                query[filter_type_slug];
        }
    });
    return additionalQueryParams;
}

export async function getServerSideProps({ query, res }) { 
    console.log('from serv : ' + process.env.NODE_ENV)
    let exactRoute = query.route; //grab the route from url
    let data = null;
    
    const endpoint = await getEndpoint(query)
    try {
        if(query.route == 'location'){
            const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-landing-page?page=${query.route}`);
            data = await req.json()
            exactRoute = 'location'
        }
        else if(endpoint == null) {
            const additionalQueryParams = getQueryParams(query);
            const req = await fetch(`${process.env.BASE_API_URL}get-category?slug=${exactRoute}${additionalQueryParams}`); //find the category data from the url
            data = await req.json();
            exactRoute = 'category';
        }
        else { //category
            const per_page = endpoint?.per_page ? `&per_page=${endpoint.per_page}` : "";
            const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-articles?type=${endpoint.route}&page=${endpoint.page}${per_page}`);
            data = await req.json();
            exactRoute = 'article';
        }
    
        if(data.status=='failed' || data.exception){
            return {notFound: true} //404
        }
    
        res.setHeader(
            'Cache-Control',
            'public, s-maxage=43200, stale-while-revalidate=59'
        )
        return {
            props: {
                //pass props into route
                data,
                exactRoute,
            },
        };

    } catch (error) {
        return {
            notFound: true
        }
    }

}

// export async function getStaticProps({ params}) { //TODO: when more JS functionality is created, check how SSG (static site generation) would work with filters, specified account pricing, etc
//TODO: when re-enabled, turn prefetching on links to false
//     // const exactRoute = query.route; //grab the route from url
//     const exactRoute = params.route; //grab the route from url

//     const req = await fetch(`${process.env.BASE_API_URL}get-category?slug=${exactRoute}`) //find the category data from the url
//     const categoryData = await req.json()

//     return {
//         props: { //pass props into route
//             categoryData,
//             exactRoute
//         },
//         revalidate: 120
//     }
// }
// export async function getStaticPaths() {
//     return {
//       paths: [],
//       fallback: 'blocking',
//     }
// }

export default DynamicRoute;
